import type { BadgeTone } from "@/components/ui/Badge";

import type {
  CoverageKind,
  DataQualityIssueStatus,
  DataQualitySeverity,
  SourceAdmission,
} from "./dataQualityApi";

const MINUTES_IN_HOUR = 60;

const COVERAGE_COLOURS: Record<CoverageKind, string> = {
  CARD: "bg-success",
  VEHICLE_UNIT_ONLY: "bg-warning",
  CONFLICT: "bg-danger",
  NOT_ADMITTED: "bg-border-strong",
  MISSING: "bg-surface-sunken",
};

const COVERAGE_MEANINGS: Record<CoverageKind, string> = {
  CARD: "Aktywności z karty kierowcy dopuszczone do obliczeń.",
  VEHICLE_UNIT_ONLY: "Aktywności wyłącznie z jednostki pojazdowej, wyniki są przybliżone.",
  CONFLICT: "Dwa źródła zawierają sprzeczne informacje, wymaga rozstrzygnięcia.",
  NOT_ADMITTED: "Dane wyłącznie z pliku o nieważnym podpisie, niedopuszczone do obliczeń.",
  MISSING: "Brak danych o aktywności kierowcy.",
};

const ADMISSION_TONES: Record<SourceAdmission, BadgeTone> = {
  VERIFIED: "success",
  UNVERIFIED: "warning",
  ACCEPTED_BY_DECISION: "warning",
  NOT_ADMITTED: "error",
  PENDING: "neutral",
};

const SEVERITY_TONES: Record<DataQualitySeverity, BadgeTone> = {
  BLOCKING: "error",
  WARNING: "warning",
  INFO: "neutral",
};

const STATUS_TONES: Record<DataQualityIssueStatus, BadgeTone> = {
  OPEN: "warning",
  ACCEPTED: "neutral",
  RESOLVED: "muted",
};

export const ISSUE_TYPE_OPTIONS = [
  { value: "MISSING_ACTIVITY", label: "Brak aktywności kierowcy" },
  { value: "SOURCE_CONFLICT", label: "Sprzeczne źródła" },
  { value: "INVALID_SIGNATURE", label: "Nieważny podpis pliku" },
  { value: "UNVERIFIABLE_SIGNATURE", label: "Podpisu pliku nie da się zweryfikować" },
  { value: "UNASSIGNED_FILE", label: "Plik bez przypisania" },
  { value: "INCOMPLETE_COVERAGE", label: "Dane wyłącznie z jednostki pojazdowej" },
  { value: "INCONSISTENT_RECORD", label: "Plik nie został odczytany" },
];

export const ISSUE_STATUS_OPTIONS = [
  { value: "OPEN", label: "Otwarte" },
  { value: "ACCEPTED", label: "Zaakceptowane decyzją" },
  { value: "RESOLVED", label: "Zamknięte" },
];

export function coverageColour(kind: CoverageKind): string {
  return COVERAGE_COLOURS[kind];
}

export function coverageMeaning(kind: CoverageKind): string {
  return COVERAGE_MEANINGS[kind];
}

export function admissionTone(admission: SourceAdmission): BadgeTone {
  return ADMISSION_TONES[admission];
}

export function severityTone(severity: DataQualitySeverity): BadgeTone {
  return SEVERITY_TONES[severity];
}

export function issueStatusTone(status: DataQualityIssueStatus): BadgeTone {
  return STATUS_TONES[status];
}

export function formatMinutes(minutes: number): string {
  if (minutes < MINUTES_IN_HOUR) {
    return `${String(minutes)} min`;
  }
  const rest = minutes % MINUTES_IN_HOUR;
  const hours = Math.floor(minutes / MINUTES_IN_HOUR);
  return rest === 0 ? `${String(hours)} godz.` : `${String(hours)} godz. ${String(rest)} min`;
}
